import { UserAvatarAndName } from "../../../../components/shared/org/avatar-for-user";
import { Button } from "../../../../components/ui/button";
import React from "react";
import { TypedToolInvocation } from "../utils";
import { CheckIcon, ExternalLinkIcon } from "lucide-react";
import { useScheduleEvent } from "../../../../lib/event-scheduling";
import { useOrg, useOrgUserMap } from "../../../../auth/org-provider";
import { useProject } from "../../../../data/project";

export function SuggestMeetingToolInvocation({ invocation }: { invocation: TypedToolInvocation<"suggestMeeting"> }) {
    const { args } = invocation;
    const scheduleEvent = useScheduleEvent();
    const org = useOrg();
    const { project } = useProject();
    const users = useOrgUserMap();

    const handleSchedule = () => {
        scheduleEvent(org.officeSuiteProvider, {
            description: args.meetingDescription,
            eventName: args.meetingTitle,
            invitees: args.invitees.map((id) => users[id]!.email),
            meetingDuration: { minutes: 30 },
            context: { projectId: project.id, scope: ["chat"] },
        });
    };

    return (
        <div className={"flex flex-col items-start gap-2 rounded-md border p-2 text-sm"}>
            <div className={"font-semibold"}>{args.meetingTitle}</div>
            <div>{args.meetingDescription}</div>
            <div className={"flex flex-row flex-wrap items-center gap-3"}>
                {args.invitees.map((i) => (
                    <div className={"flex flex-row items-center"} key={i}>
                        <UserAvatarAndName avatarClassName={"w-5 h-5 me-2"} avatarFallback={"icon"} userId={i} />
                    </div>
                ))}
            </div>
            {invocation.result?.status === "to_be_scheduled_by_user" && (
                <Button onClick={handleSchedule} className={"mt-2"}>
                    Schedule
                    <ExternalLinkIcon className={"ms-2 h-5 w-5"} />
                </Button>
            )}
            {invocation.result?.status === "scheduled" && (
                <Button variant={"outline"} size={"sm"} disabled className={"mt-2"}>
                    <CheckIcon className={"me-2 h-5 w-5"} /> Scheduled
                </Button>
            )}
        </div>
    );
}
